<script setup lang="ts">
import { toasts, dismiss } from '../game/toast';
</script>

<template>
  <div class="th" aria-live="polite">
    <TransitionGroup name="th">
      <button
        v-for="t in toasts" :key="t.id"
        class="th-toast" :class="`th-${t.kind}`"
        :style="t.accent ? { '--th-rail': t.accent } : undefined"
        @click="dismiss(t.id)"
      >
        <img v-if="t.icon" :src="t.icon" alt="" class="th-icon" />
        <span class="th-msg">{{ t.message }}</span>
      </button>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.th {
  position: fixed;
  bottom: 22px; left: 50%;
  transform: translateX(-50%);
  z-index: 400;
  display: flex; flex-direction: column-reverse; align-items: center; gap: 8px;
  pointer-events: none;
  width: min(480px, calc(100vw - 32px));
}
.th-toast {
  pointer-events: auto;
  display: flex; align-items: center; gap: 10px;
  max-width: 100%;
  padding: 10px 18px 10px 14px;
  border: 1px solid color-mix(in srgb, var(--th-rail, var(--color-gold)) 40%, transparent);
  border-left: 3px solid var(--th-rail, var(--color-gold));
  border-radius: 8px;
  background: linear-gradient(165deg, rgba(22, 18, 28, 0.96), rgba(10, 8, 14, 0.98));
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6), 0 0 18px color-mix(in srgb, var(--th-rail, var(--color-gold)) 12%, transparent);
  backdrop-filter: blur(4px);
  cursor: pointer;
  text-align: left;
}
.th-success { --th-rail: var(--color-gold); }
.th-error { --th-rail: var(--color-error); }
.th-info { --th-rail: var(--color-purple-light); }
.th-icon {
  width: 26px; height: 26px; flex: none;
  object-fit: contain;
  border-radius: 5px;
  filter: drop-shadow(0 0 6px rgba(200, 162, 76, 0.35));
}
.th-msg {
  font-family: var(--font-body, serif);
  font-size: 14.5px; line-height: 1.35;
  color: var(--color-text);
}
.th-error .th-msg { color: color-mix(in srgb, var(--color-error) 35%, var(--color-text)); }

.th-enter-active { transition: opacity 240ms ease, transform 240ms cubic-bezier(0.2, 1.1, 0.35, 1); }
.th-leave-active { transition: opacity 200ms ease, transform 200ms ease; }
.th-enter-from { opacity: 0; transform: translateY(14px) scale(0.97); }
.th-leave-to { opacity: 0; transform: translateY(6px); }
@media (prefers-reduced-motion: reduce) {
  .th-enter-active, .th-leave-active { transition: none; }
}
</style>
